<template>
<div>
  <Loading :loading="this.loading"></Loading>
  <div v-show="!loading" class="content-wrapper">
    <div class="container">
      <article>

        <section class="section white-panel mb8">
          <h2 class="fs18 text-center mt4 mb12">コスモ石油で燃料油が会員価格に。</h2>
          <p class="mb0 text-center">
            <img src="/lib/images/cosmo-house-card.png" class="w60p" alt="">
          </p>
        </section>

        <div class="border-solid-gray bg-white radius16 pt12 pd4 ml12 mr12 mt2p mb0">
            <p class="fs13 mt4 mb4 text-center">オンラインでカードお申込みが完結！
<br>書類の郵送･お届け印不要</p>
          <div class="transparent-panel">
            <button v-on:click="jsOpenBrowser(houseUrl + mySsCord, 'OPEN_SMBC_PAGE', { 'tappedSsCode':mySsCord })" class="button-house fs16 mt8 mb16 pd16 radius200">今すぐお申込み</button>
          </div>
        </div>

            <p class="fs11 mt4 mb8 text-center">※こちらから申込頂くと、現在選択されているSSから<br>お知らせが届く場合がございます</p>

        <section class="section white-panel pl0 pr0">
          <div class="bg-grad-green-house pt16">
            <h2 class="fs18 mt4 mb12 pl12 color-white">特典</h2>
            <ul class="list-special-house ml12 mr12">
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">１</span></p>
                <p class="fs16 font-weight-bold mb0">入会特典10円／Lキャッシュバック！（最大500円分）</p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">2</span></p>
                <p class="fs16 font-weight-bold mb0">初年度年会費無料<br>
                ネットde明細登録で、２年目以降も無料
                </p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">3</span></p>
                <p class="fs16 font-weight-bold mb0 line-height1_2">会員価格でおトクに給油</p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">4</span></p>
                <p class="fs16 font-weight-bold mb0">選べるハローキティデザイン<br>
                ハローキティデザインのカードが選べます</p>
              </li>
              <li class="">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">5</span></p>
                <p class="fs15 font-weight-bold mb0">ETC一体型カードも選べます</p>
              </li>
              <li class="mb0">
                <p class="num fs14 font-weight-bold text-center"><span>特典</span><span class="fs20">6</span></p>
                <p class="fs14 font-weight-bold mb0 line-height1_2">給油・カーケアのご利用でマイルが貯まる！<br>
                マイルはプレゼント応募やキャッシュバックに使えます</p>
              </li>
            </ul>
          </div>
        </section>

        <p class="text-center ttl-ribon-eco"><img src="/lib/images/ttl-ribon-house-eco.png" class="w80p" alt="コスモ･ザ･カード･ハウス「エコ」"></p>

        <div class="border-solid-gray bg-white radius16 pt48 pd4 ml12 mr12 mt0 mb0">
            <p class="mb16 text-center"><img src="/lib/images/cosmo-house-card-eco.png" class="w60p" alt=""></p>
            <p class="fs14 mt4 mb16 text-center card-info-text">コスモ･ザ･カード･ハウスの特典に加え、
            お客さまからお預かりする毎年500円とコスモ石油からの寄付金をNPOや公益法人などに寄付することでその活動をサポートしていきます。</p>
          <div class="transparent-panel">
            <button v-on:click="jsOpenBrowser(houseUrl + mySsCord, 'OPEN_SMBC_ECOPAGE', { 'tappedSsCode':mySsCord })" class="button-house fs16 mt8 mb16 pd16 radius200">今すぐお申込み</button>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import profileApi from '@/store/Api/Common/profile'
import modal from '@/assets/v2/modal'
import Loading from '@/views/v2/Loading.vue'

export default {
  data () {
    return {
      loading: true,
      mySsCord: '',
      houseUrl: process.env.VUE_APP_HOUSE_URL,
      profileInfo: []
    }
  },
  methods: {
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    jsOpenBrowser: function (url, type, customParameters) {
      // 今すぐお申込みボタン
      if (type === 'OPEN_SMBC_PAGE') {
        this.nativeEVENTSet('HouseCardNyukaiButton', type, 'TAP', customParameters)
      }
      // 今すぐお申込みボタン ECO
      if (type === 'OPEN_SMBC_ECOPAGE') {
        this.nativeEVENTSet('HouseEcoCardNyukaiButton', type, 'TAP', customParameters)
      }
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    }
  },
  computed: {
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
      this.mySsCord = res.data.body.best_myss.code
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // [eventTrack] カードスペック画面表示完了
    this.nativePVset('HOUSECARD_NYUKAI_SOKUSHIN')
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}

</script>
